import type { ReactNode } from 'react';
import { Check, ClipboardPaste, FileSpreadsheet } from 'lucide-react';
import { CabecalhoSecao } from './CabecalhoSecao';
import { ChavesColadas, ResumoSped } from './Mockups';
import base from './publico.module.css';
import css from './Secoes.module.css';

/** Os dois caminhos de entrada: a lista de chaves e o arquivo SPED. */
export function DuasFormas() {
  return (
    <section id="formas" className={`${base.secao} ${base.secaoSuave}`}>
      <div className={base.conteudo}>
        <CabecalhoSecao sobretitulo="Duas formas de usar" titulo="Pela chave de acesso ou direto do SPED">
          Use a que for mais prática no dia — e misture à vontade ao longo do
          mês. Nos dois casos o resultado é o mesmo: um ZIP com um XML por nota.
        </CabecalhoSecao>

        <div className={css.formas}>
          <Forma
            icone={<ClipboardPaste />}
            titulo="Pela chave de acesso"
            texto="Cole a lista, digite ou envie um CSV ou planilha exportada do seu sistema. Lemos as sequências de 44 dígitos de qualquer coluna."
            visual={<ChavesColadas />}
            itens={[
              'De uma chave a um milhão por lote. Chaves repetidas são descartadas automaticamente.',
              'Lote retomável: o progresso é gravado a cada chave concluída — reiniciar o serviço não recomeça o trabalho.',
              'Dá para baixar o parcial a qualquer momento, enquanto o lote ainda roda.',
            ]}
          />
          <Forma
            icone={<FileSpreadsheet />}
            titulo="Direto do SPED"
            texto="EFD ICMS/IPI e EFD Contribuições, arquivos soltos ou em .zip. Notas repetidas entre os arquivos são unificadas, e ECD/ECF são reconhecidos sem quebrar a análise."
            visual={<ResumoSped />}
            itens={[
              'Filtros que contam: competência, CFOP, modelo, entrada/saída, situação e participante, cada opção com a quantidade de notas.',
              'Enviar e analisar o SPED é gratuito — o crédito só é usado no download.',
              'O que estiver escriturado e sem XML aparece na hora.',
            ]}
          />
        </div>
      </div>
    </section>
  );
}

function Forma({
  icone,
  titulo,
  texto,
  visual,
  itens,
}: {
  icone: ReactNode;
  titulo: string;
  texto: string;
  visual: ReactNode;
  itens: string[];
}) {
  return (
    <article className={css.forma}>
      <div className={css.formaVisual}>{visual}</div>
      <div className={css.formaTexto}>
        <h3 className={css.formaTitulo}>
          <span className={css.iconeQuadro} aria-hidden="true">
            {icone}
          </span>
          {titulo}
        </h3>
        <p className={css.paragrafo}>{texto}</p>
        <ul className={css.checklist}>
          {itens.map((i) => (
            <li key={i}>
              <Check aria-hidden="true" />
              <span>{i}</span>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}
